export default __webpack_public_path__ + "static/media/calendar.a40e0012.svg";